<template>
  <div class="patient-info-wrapper">
    <h2 class="title">1.问诊人信息</h2>
    <el-form :model="formData" label-position="left" ref="patientInfoForm" label-width="80px" :rules="rules">
      <el-tabs v-model="verifType" v-if="!needIdNo">
        <el-tab-pane v-for="(tab, index) in tabs" :key="index" :label="tab.title" :name="tab.type"></el-tab-pane>
      </el-tabs>
      <el-row>
        <el-col :span="16">
          <el-form-item label="患者身份">
            <el-radio-group v-model="patientType">
              <el-radio :label="PATIENT_TYPE.ADULT" @click.native.prevent="selectPatientType(PATIENT_TYPE.ADULT)">
                成人
              </el-radio>
              <el-radio :label="PATIENT_TYPE.CHILD" @click.native.prevent="selectPatientType(PATIENT_TYPE.CHILD)">
                儿童
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col v-if="nowNeedParams.includes('name')" :span="7">
          <el-form-item prop="name" label="患者姓名">
            <!--            <el-input v-model="formData.name" :maxlength="20" placeholder="请输入患者姓名"></el-input>-->
            <el-autocomplete
              value-key="name"
              v-model="formData.name"
              :maxlength="20"
              placeholder="请输入患者姓名"
              :fetch-suggestions="querySearchAsyncName"
              @select="nameSelect"
            >
              <div slot-scope="{ item }">
                <div class="info" v-html="brightenKeyword(item, 'name')"></div>
              </div>
            </el-autocomplete>
          </el-form-item>
        </el-col>
        <el-col v-if="nowNeedParams.includes('phoneNumber')" :span="8">
          <el-form-item prop="phoneNumber" label="患者电话">
            <el-autocomplete
              value-key="name"
              v-model="formData.phoneNumber"
              :maxlength="11"
              placeholder="请输入患者电话"
              :fetch-suggestions="querySearchAsyncPhone"
              @select="nameSelect"
            >
              <div slot-scope="{ item }">
                <div class="info" v-html="brightenKeyword(item, 'phoneNumber')"></div>
              </div>
            </el-autocomplete>
            <!--            <el-input-->
            <!--              v-model="formData.phoneNumber"-->
            <!--              :maxlength="11"-->
            <!--              placeholder="请输入患者电话"-->
            <!--              @blur="getUserinfoByNameOrMobile(formData.phoneNumber)"-->
            <!--            ></el-input>-->
          </el-form-item>
        </el-col>
        <el-col v-if="nowNeedParams.includes('verifyCode') && !isChild" :span="9">
          <send-code v-model="formData.verifyCode" :mobile="formData.phoneNumber" :type="2"></send-code>
        </el-col>
      </el-row>
      <el-row>
        <el-col v-if="nowNeedParams.includes('idNo')" :span="12">
          <el-form-item prop="idNo" label="身份证/社会保障号码" label-width="160px">
            <el-input v-model="formData.idNo" @blur="validateIdNo" placeholder="请输入身份证/社会保障号码"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col v-if="nowNeedParams.includes('weight')" :span="8">
          <el-form-item prop="weight" label="体重">
            <el-input v-model="formData.weight" placeholder="请输入体重（kg）"></el-input>
          </el-form-item>
        </el-col>
        <el-col v-if="nowNeedParams.includes('ages')" :span="8">
          <el-form-item prop="ages" label="年龄">
            <el-input v-model="formData.ages" :maxlength="6" placeholder="请输入年龄" @blur="validateAge"></el-input>
          </el-form-item>
        </el-col>
        <el-col v-if="nowNeedParams.includes('gender')" :span="8">
          <el-form-item prop="gender" label="性别">
            <el-select v-model="formData.gender" placeholder="请选择">
              <el-option
                v-for="(item, index) in Constant.sexType"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div v-if="isChild">
        <h3 class="m-title">监护人信息</h3>
        <el-row :gutter="20">
          <el-col v-if="nowNeedParams.includes('guardianMobile')" :span="8">
            <el-form-item prop="guardianMobile" :maxlength="11" label="监护人电话" label-width="100px">
              <!--              <el-input-->
              <!--                v-model="formData.guardianMobile"-->
              <!--                placeholder="请输入监护人电话"-->
              <!--                @blur="getUserinfoByNameOrMobile(formData.guardianMobile)"-->
              <!--              ></el-input>-->
              <el-autocomplete
                value-key="name"
                v-model="formData.guardianMobile"
                :maxlength="11"
                placeholder="请输入患者电话"
                :fetch-suggestions="querySearchAsyncPhone"
                @select="nameSelect"
              >
                <div slot-scope="{ item }">
                  <div class="info" v-html="brightenKeyword(item, 'phoneNumber')"></div>
                </div>
              </el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="9" v-if="nowNeedParams.includes('guardianVerifyCode')">
            <send-code
              v-model="formData.guardianVerifyCode"
              :mobile="formData.guardianMobile"
              :type="2"
              prop="guardianVerifyCode"
            ></send-code>
          </el-col>
        </el-row>
        <el-row>
          <el-col v-if="nowNeedParams.includes('guardianName')" :span="8">
            <el-form-item prop="guardianName" label="监护人姓名" label-width="100px">
              <el-input v-model="formData.guardianName" :maxlength="20" placeholder="请输入监护人姓名"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <!-- <el-form-item>
        <el-button type="primary" @click="test">立即创建</el-button>
      </el-form-item> -->
    </el-form>
  </div>
</template>
<script>
import { VERIFY_TYPE, PATIENT_TYPE, SIMPLE_CHINESE_NAME } from '@/lib/constant';
import { judgeMobile, isEmpty, verifyIdentityNum } from '@/util';
import { getIdCardMessage } from '@fastweb/f2e-utils';
import SendCode from '@/components/global/sendCode';
import { mapState } from 'vuex';

const needParams = {
  [VERIFY_TYPE.IDNO]: {
    [PATIENT_TYPE.ADULT]: ['phoneNumber', 'name', 'idNo'],
    [PATIENT_TYPE.CHILD]: ['name', 'idNo', 'weight', 'guardianMobile', 'guardianName']
  },
  [VERIFY_TYPE.CODE]: {
    [PATIENT_TYPE.ADULT]: ['phoneNumber', 'name', 'ages', 'gender'],
    [PATIENT_TYPE.CHILD]: ['name', 'ages', 'gender', 'weight', 'guardianMobile', 'guardianName']
  }
};
export default {
  name: 'patientInfo',
  components: { SendCode },
  props: {
    maxAge: {
      type: Number,
      default: 200
    }
  },
  computed: {
    ...mapState('global', ['needIdNo']),
    nowNeedParams() {
      let { verifType, patientType, isOld, isOldGuardian } = this;
      let nowNeedParams = [];
      nowNeedParams = [...needParams[verifType][patientType]];
      // 只有验证码申请需要发送验证码
      if (verifType == VERIFY_TYPE.CODE) {
        if (patientType == PATIENT_TYPE.ADULT && !isOld) {
          nowNeedParams.push('verifyCode');
        } else if (patientType == PATIENT_TYPE.CHILD && !isOldGuardian) {
          nowNeedParams.push('guardianVerifyCode');
        } else {
          nowNeedParams = this.deleteArrEl(nowNeedParams, ['verifyCode', 'guardianVerifyCode']);
        }
      } else {
        nowNeedParams = this.deleteArrEl(nowNeedParams, ['verifyCode', 'guardianVerifyCode']);
      }
      return nowNeedParams;
    },
    isChild() {
      let { patientType } = this;
      return patientType == PATIENT_TYPE.CHILD;
    }
  },
  watch: {
    formData: {
      handler(val, oldVal) {
        if (val.age !== oldVal.age || val.gender !== oldVal.gender) {
          this.$emit('checkCaseHistoryUploadRemind');
        }
      },
      deep: true
    }
  },
  data() {
    return {
      VERIFY_TYPE: VERIFY_TYPE,
      PATIENT_TYPE: PATIENT_TYPE,
      verifType: VERIFY_TYPE.IDNO, // 申请方式
      patientType: PATIENT_TYPE.ADULT, // 患者类型
      Constant: Constant,
      tabs: [
        {
          title: '身份证申请',
          type: VERIFY_TYPE.IDNO
        },
        {
          title: '手机号申请',
          type: VERIFY_TYPE.CODE
        }
      ],
      formData: {},
      rules: {
        name: [
          { required: true, message: '请输入患者姓名', trigger: 'blur' },
          { max: 20, message: '姓名最多支持20个字', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (/^[\u4e00-\u9fa5][\u4e00-\u9fa5·]{0,18}?[\u4e00-\u9fa5]$/.test(value) && !/·{2,}/.test(value)) {
                callback();
              } else {
                callback(Error('姓名填写不规范，请检查'));
              }
            },
            trigger: 'blur'
          }
        ],
        phoneNumber: [
          { required: true, message: '请输入患者电话', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (!judgeMobile(value)) {
                callback(Error('请输入正确手机号码'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        idNo: [
          { required: true, message: '请输入身份证/社会保障号码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (!verifyIdentityNum(value)) {
                callback(Error('请输入正确身份证/社会保障号码'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        weight: [
          { required: true, message: '请输入体重', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (!/^[0-9]+([.]{1}[0-9]{1})?$/.test(value)) {
                callback(Error('请输入正确体重'));
              } else if (value > 100 || value <= 0) {
                callback(Error('请输入正确体重'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        guardianMobile: [
          { required: true, message: '请输入监护人电话', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (!judgeMobile(value)) {
                callback(Error('请输入正确监护人电话'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        guardianName: [
          { required: true, message: '请输入监护人姓名', trigger: 'blur' },
          { max: 20, message: '姓名最多支持20个字', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (/^[\u4e00-\u9fa5][\u4e00-\u9fa5·]{0,18}?[\u4e00-\u9fa5]$/.test(value) && !/·{2,}/.test(value)) {
                callback();
              } else {
                callback(Error('姓名填写不规范，请检查'));
              }
            },
            trigger: 'blur'
          }
        ],
        verifyCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (/[^0-9]/g.test(value)) {
                callback(Error('请输入正确验证码'));
              } else if (value.length != 4) {
                callback(Error('请输入正确验证码'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        guardianVerifyCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (/[^0-9]/g.test(value)) {
                callback(Error('请输入正确验证码'));
              } else if (value.length != 4) {
                callback(Error('请输入正确验证码'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
        ages: [
          { required: true, message: '请输入患者年龄', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (/[^0-9]/g.test(value)) {
                callback(Error('请输入正确患者年龄'));
              } else if (value < 0 || value > this.maxAge) {
                callback(Error(`最大年龄${this.maxAge}岁`));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ]
      },
      isOld: true, // 新老用户
      isOldGuardian: true // 老监护人
    };
  },
  methods: {
    async test() {
      try {
        let res = await this.validatePatientInfo();
        console.log('res', res);
      } catch (error) {
        console.log('error', error);
      }
    },
    // 校验病人信息
    validatePatientInfo() {
      return new Promise(async (resolve, reject) => {
        try {
          let valid = await this.$refs.patientInfoForm.validate();
          if (valid) {
            let { nowNeedParams, formData, patientType } = this;
            let params = {};
            nowNeedParams.forEach(param => {
              // 监护人的验证码对于后端而言都是一个字端，前端为了区分值，换了字端名
              if (param == 'guardianVerifyCode') {
                params.verifyCode = formData[param];
              } else {
                params[param] = formData[param];
              }
              params.patientType = patientType;
            });
            // console.log('params', params);
            resolve({ valid: true, params });
          } else {
            resolve({ valid: false });
            // reject(new Error(false));
          }
        } catch (error) {
          resolve({ valid: false });
          // reject(error);
        }
      });
    },
    brightenKeyword(item, mode) {
      let keyword = '';
      const { name: allname, mobile } = item;
      if (mode == 'name') {
        const { phoneNumber, name } = this.formData;
        // 按名字搜索
        keyword = name;
        const phone = this.hidePhoneNumber(mobile);
        const Reg = new RegExp(keyword, 'i');
        const nameEle = allname.replace(Reg, `<span style="color: #409EFF;">${keyword}</span>`);
        const phoneEle = `<span>${phone}</span>`;
        return `${nameEle}，${phoneEle}`;
      } else if (mode == 'phoneNumber') {
        const { phoneNumber, name } = this.formData;
        keyword = phoneNumber;
        const phone = this.hidePhoneNumber(mobile);
        const nameEle = `<span>${allname}</span>`;
        const phoneEle = `<span>${phone}</span>`;
        return `${nameEle}，${phoneEle}`;
      }
    },
    hidePhoneNumber(phoneNumber) {
      const reg = /^(\d{3})\d{4}(\d{4})$/;
      return phoneNumber.replace(reg, '$1****$2');
    },
    async nameSelect(item) {
      const { id } = item;
      const res = await Fetch.query_patient_by_id({ patientId: id });
      this._setUserInfo_name(res);
    },
    async querySearchAsyncName(queryString, cb) {
      if (!queryString) {
        cb([]);
        return;
      }
      let { patientType, formData } = this;
      let param = {
        patientType: patientType,
        name: queryString
      };
      const res = await Fetch.getUserinfoByNameOrMobile(param);

      cb(res);
    },
    async querySearchAsyncPhone(queryString, cb) {
      if (!queryString) {
        cb([]);
        return;
      }
      let { patientType, formData } = this;
      let param = {
        patientType: patientType,
        mobile: queryString
      };
      const res = await Fetch.getUserinfoByNameOrMobile(param);

      cb(res);
    },
    _setUserInfo_name(res) {
      let { patientType, formData } = this;
      // 产品需求不管新老用户都需要展示验证码，后端走灰度，兼容后端灰度状态下通过新增字段isVerifyCode来判断是否需求显示验证码
      const { isVerifyCode } = res;
      if (isVerifyCode) {
        this.setIsOld(patientType, false);
      } else {
        this.setIsOld(patientType, true);
      }
      // 成人
      if (patientType == PATIENT_TYPE.ADULT) {
        // this.isOld = true;
        if (patientType == VERIFY_TYPE.IDNO) {
          // 身份证申请
          formData = {
            ...formData,
            name: res?.name,
            idNo: res?.idNo,
            gender: res?.gender?.toString(),
            ages: res?.ages,
            phoneNumber: res?.mobile
          };
        } else {
          // 验证码申请
          formData = {
            ...formData,
            name: res?.name,
            idNo: res?.idNo,
            gender: res?.gender?.toString(),
            ages: res?.ages,
            phoneNumber: res?.mobile
          };
        }
      } else {
        formData = {
          ...formData,
          idNo: res?.idNo,
          guardianName: res?.guardianName,
          guardianMobile: res?.mobile,
          name: res?.name,
          ages: res?.ages,
          gender: res?.gender?.toString()
        };
      }

      this.$emit('initPastHistory', res?.pastHistory);

      this.formData = { ...formData };
      this.$nextTick(() => {
        this.$refs.patientInfoForm.validate();
      });
    },
    // 老逻辑 现在不需要了
    getUserinfoByNameOrMobile(mobile) {
      let { patientType, formData } = this;
      if (!judgeMobile(mobile)) return;
      let param = {
        patientType: patientType,
        mobile: mobile
      };
      Fetch.getUserinfoByNameOrMobile(param)
        .then(resArray => {
          const res = resArray[0];
          if (!isEmpty(res)) {
            let { patientType, formData } = this;
            // 产品需求不管新老用户都需要展示验证码，后端走灰度，兼容后端灰度状态下通过新增字段isVerifyCode来判断是否需求显示验证码
            const { isVerifyCode } = res;
            if (isVerifyCode) {
              this.setIsOld(patientType, false);
            } else {
              this.setIsOld(patientType, true);
            }
            // 成人
            if (patientType == PATIENT_TYPE.ADULT) {
              // this.isOld = true;
              if (patientType == VERIFY_TYPE.IDNO) {
                // 身份证申请
                if (!formData.name && !formData.idNo) {
                  formData = {
                    ...formData,
                    name: res?.name,
                    idNo: res?.idNo,
                    gender: res?.gender?.toString(),
                    ages: res?.ages
                  };
                }
              } else {
                // 验证码申请
                if (!formData.name && !formData.gender && !formData.ages) {
                  formData = {
                    ...formData,
                    name: res?.name,
                    idNo: res?.idNo,
                    gender: res?.gender?.toString(),
                    ages: res?.ages
                  };
                }
              }
            } else {
              // this.isOldGuardian = true;
              // 儿童
              if (!formData.guardianName) {
                formData = {
                  ...formData,
                  guardianName: res?.guardianName
                };
              }
            }

            this.$emit('initPastHistory', res?.pastHistory);

            this.formData = { ...formData };
          } else {
            this.setIsOld(patientType, false);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    setIsOld(patientType, flag) {
      if (patientType == PATIENT_TYPE.ADULT) {
        this.isOld = flag;
      } else {
        this.isOldGuardian = flag;
      }
    },
    // 校验身份证
    validateIdNo() {
      let { formData } = this;
      let { idNo } = formData;
      if (idNo) {
        let isIdNo = verifyIdentityNum(idNo);
        // 如果输入身份证，自动算出性别和年龄
        if (isIdNo) {
          let info = getIdCardMessage(idNo);
          formData.ages = info.age;
          formData.gender = info.gender;
        } else {
          formData.ages = null;
          formData.gender = null;
        }
      } else {
        formData.ages = null;
        formData.gender = null;
      }
      this.formData = { ...formData };
      this.setPatientType();
    },
    // 选择患者类型
    async selectPatientType(type) {
      this.patientType = this.patientType;
      let { ages } = this.formData;
      if (type == PATIENT_TYPE.ADULT) {
        if (ages && ages <= 14) {
          this.$message({
            message: '大于14岁以上为成人',
            type: 'warning'
          });
          return;
        }
      }

      if (type == PATIENT_TYPE.CHILD) {
        let isLimitChild = await this.isLimitChild(ages);
        if (!isLimitChild) return;

        if (ages && ages > 14) {
          this.$message({
            message: '儿童年龄在14岁以下',
            type: 'warning'
          });
          return;
        }
      }
      this.patientType = type;
    },
    // 根据年龄自动设置患者类型
    async setPatientType() {
      let { patientType } = this;
      let { ages } = this.formData;
      if (!isEmpty(ages)) {
        if (ages <= 14) {
          let isLimitChild = await this.isLimitChild(ages);
          if (!isLimitChild) return;
          this.patientType = PATIENT_TYPE.CHILD;
        } else if (ages > 14) {
          this.patientType = PATIENT_TYPE.ADULT;
        }
      }
    },
    // 获取6岁一下儿童是否可以开具处方
    isLimitChild(ages) {
      return new Promise(async (resolve, reject) => {
        const { limitChildrenAge = -1 } = await Fetch.getChildrenLimitInfo();
        if (limitChildrenAge !== -1) {
          if (isEmpty(ages)) {
            this.$message({
              message: `${limitChildrenAge}岁以下儿童请到线下医院就诊`,
              type: 'warning'
            });
          } else {
            if (ages <= limitChildrenAge) {
              this.$message({
                message: `${limitChildrenAge}岁以下儿童请到线下医院就诊`,
                type: 'warning'
              });
              resolve(false);
            }
          }
        }
        resolve(true);
      });
    },
    // 校验年龄
    validateAge() {
      this.setPatientType();
    },
    // 删除数组中的元素
    deleteArrEl(arr, params) {
      // 删除前去重
      arr = Array.from(new Set(arr));
      params.map(param => {
        if (arr.includes(param)) {
          let index = arr.findIndex(item => item == param);
          arr.splice(index, 1);
        }
      });
      return arr;
    }
  }
};
</script>
<style lang="scss" scoped>
.patient-info-wrapper {
  /deep/.el-radio {
    display: inline-block;
  }
  /deep/.el-tabs__item {
    color: #707070;
  }
  /deep/.el-tabs__nav-wrap::after {
    height: 1px;
    background-color: #f2f2f2;
  }
  .tab-wrapper {
    display: flex;
  }
  .title,
  .m-title {
    color: #242424;
    font-size: 16px;
    font-weight: bold;
  }
  .m-title {
    color: #707070;
  }
}
</style>
